"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelAgentTier = void 0;
var TravelAgentTier;
(function (TravelAgentTier) {
    TravelAgentTier["Bronze"] = "bronze";
    TravelAgentTier["Silver"] = "silver";
    TravelAgentTier["Gold"] = "gold";
})(TravelAgentTier || (exports.TravelAgentTier = TravelAgentTier = {}));
//# sourceMappingURL=travel-agent-tier.enum.js.map